import { request } from 'Features/auth/axios-client'
import { WorkCentreSummaryTableData } from 'Features/WorkCentreSummary/WorkCentreSummary.types'
import { useMutation, useQuery } from 'react-query'

const fetchSOROperationalPlans = async () => {
  const data = request({
    url: '/system-of-records/oparational-plans',
    method: 'GET',
  })
  return data
}

export const useSOROperationalPlans = () => {
  return useQuery(['SOROperationalPlans'], () => fetchSOROperationalPlans(), {
    select: ({ data }) => data?.data,
  })
}

type PublishSOROperationalPlanData = {
  planId: string
  workcentres: Pick<WorkCentreSummaryTableData, 'workCentreKey'>[]
}

const publishSOROperationalPlan = async (
  dataToServer: PublishSOROperationalPlanData
) => {
  const data = request({
    url: '/system-of-records/oparational-plans',
    method: 'POST',
    data: dataToServer,
  })
  return data
}

export const usePublishSOROperationalPlan = (
  onSuccess: () => void,
  onError: () => void
) => {
  return useMutation(publishSOROperationalPlan, {
    onSuccess,
    onError,
  })
}

const approveSOROperationalPlan = async (planId: string) => {
  const data = request({
    url: `/system-of-records/oparational-plans/${planId}/approve`,
    method: 'POST',
  })
  return data
}

export const useApproveSOROperationalPlan = (
  onSuccess: () => void,
  onError: () => void
) => {
  return useMutation(approveSOROperationalPlan, {
    onSuccess,
    onError,
  })
}
